import { Shift } from '@api'

const colorOrder: Record<number, string> = {
  1: 'bg-primary-500',
  2: 'bg-pink-500',
  3: 'bg-teal-500',
  4: 'bg-orange-300',
  5: 'bg-green-300',
  6: 'bg-blue-300',
  7: 'bg-purple-300',
  8: 'bg-yellow-300',
  9: 'bg-red-300',
  10: 'bg-secondary-300',
  11: 'bg-teal-800',
  12: 'bg-purple-700',
}

export const getColorKey = (shift: Shift): string => {
  return shift.members
    .map(({ id }) => id)
    .sort((a, b) => a! - b!)
    .join(',')
}

export const getColorMap = (shifts: Shift[]): Record<string, string> => {
  return shifts.reduce<Record<string, string>>((map, shift) => {
    const order = Object.entries(map).length + 1
    const colorsLength = Object.values(colorOrder).length

    const repeatableOrder =
      order <= colorsLength ? order : order % colorsLength || colorsLength

    map[getColorKey(shift)] ||= colorOrder[repeatableOrder]

    return map
  }, {})
}
